export const apiBaseUrl = "https://retroachievements.org/API";
